import Axios from "axios";
import config from "../config";


class QrCodeService {
  constructor() {
    this.api = Axios.create({
      baseURL: config.URL_ENDPOINT,
    });
  }

  async readQrCode(image) {
    try {
      const response = await this.api.post(`/totem/qrcode`, image);
      const data = response.data;

      return data;
    } catch (error) {
      console.error("Erro ao buscar instituições", error);
      throw error;
    }
  }
}

export default QrCodeService;
